







import Vue from 'vue';
import {Component, Prop} from "vue-property-decorator";
import Company from "../../models/company/Company";
import AsiContentContainer from "../common/AsiContentContainer.vue";
import ReportList from "@/components/report/ReportList.vue";

@Component({
	components: {ReportList, AsiContentContainer}
})
export default class CompanyTabReports extends Vue {

	@Prop({type: Object, required: true})
	public company!: Company;

}
